<template>
  <div
    :style="containerStyle"
    class="bc-asset-coin-container"
  >
    <img
      :alt="alt || 'coin'"
      :src="
        imageSrc ||
          'https://globalstatic.xangle.io/images/default/project-logo.png'
      "
      :style="imageStyle"
      class="bc-asset-coin"
      @error="handleImgError"
    >
  </div>
</template>
 
<script lang="ts" setup>
import { computed } from 'vue'

import { parseDomSizeValue } from '../../utils/string.utils'


export interface IBcAssetCoin {
  imageSrc: string
  width?: string | number
  alt?: string
}

const props = withDefaults(defineProps<IBcAssetCoin>(), {
  width: 32,
  alt: '',
})

const containerStyle = computed(() => {
  return {
    width: parseDomSizeValue(props.width),
    height: parseDomSizeValue(props.width),
  }
})

const imageStyle = computed(() => {
  return {
    minWidth: parseDomSizeValue(props.width),
    minHeight: parseDomSizeValue(props.width),
  }
})

function handleImgError(e: Event) {
  const imgEl = e.target as HTMLImageElement
  if (imgEl)
    imgEl.src = 'https://globalstatic.xangle.io/images/default/project-logo.png'
}
</script>

<style lang="scss" scoped>
.bc-asset-coin-container {
  border: 1px solid rgba(var(--bc-gray), var(--o02));
  border-radius: 48%;
  display: flex;
  justify-content: center;
  align-items: center;


  .bc-asset-coin {
    background: rgba(var(--bc-absoluteWhite), var(--o1));
    border-radius: 48%;
    object-fit: cover;
  }
}
</style>
